<template>
  <v-card min-height="550">
    <v-row width="100%">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.somaticCellScore')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.performanceInfo.somaticCellScoreIndicatorMastitis')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.somaticCellScore
                    }}<span class="ml-2 text-h6 font-weight-light"
                      >count/mL</span
                    >
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >{{$t('animal.performanceInfo.lastUpdate')}} {{ animal.somaticCellScoreUD }}</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.bodyConditionScore')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.performanceInfo.scoreAnimalFat')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.bodyConditionScore
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >{{$t('animal.performanceInfo.lastUpdate')}} {{ animal.somaticCellScoreUD }}</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.teatScore')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.scoreMeasureingShapeTeats')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.teatScore
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.udderScore')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.scoreMeasureingShapeOfUdder')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.udderScore
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.birthEase')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.performanceInfo.whetherAnimalEasyBirthDifficult')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                    {{ birthEase && birthEase.text ? birthEase.text : 'Not Specified' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>

      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{$t('animal.performanceInfo.docility')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.performanceInfo.circumferenceBullScrotal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.docility
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list-item-subtitle
            class="
              mt-n6
              mb-n2
              text-overline
              font-weight-light
              text-end text--secondary
            "
            >.</v-list-item-subtitle
          >
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { birthEaseTypes, totalLongevity } from "@/models/units.js";
export default {
  created() {
    this.birthEase = this.birthEaseTypes.find(
      ({ value }) => value == this.animal.animalDetail.birthEase
    );
    this.totalLongevityS = this.totalLongevity.find(
      ({ value }) => value == this.animal.totalLongevity
    );
    console.log(this.birthEase);
  },
  data() {
    return {
      birthEaseTypes,
      totalLongevity,
    };
  },
  props: ["animal"],
};
</script>